// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cost-statistics{border-radius:10px;background:#f4f4f7}@media(min-width:768px){.cost-statistics{padding:13px 0}}.cost-statistics-item{flex:1 1 33%;display:flex;flex-direction:column;padding:0 20px}@media(min-width:768px){.cost-statistics-item:not(:first-child){border-left:1px solid #c8c8d4}}@media(max-width:767px){.cost-statistics-item:not(:last-child){border-bottom:1px solid #c8c8d4}}@media(max-width:767px){.cost-statistics-item{padding:20px 20px}}", ""]);
// Exports
module.exports = exports;
